import { render } from "./ProductionOrderRow.vue?vue&type=template&id=808a13d0&scoped=true&ts=true&lang=pug"
import script from "./ProductionOrderRow.vue?vue&type=script&lang=ts"
export * from "./ProductionOrderRow.vue?vue&type=script&lang=ts"

import "./ProductionOrderRow.vue?vue&type=style&index=0&id=808a13d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-808a13d0"]])

export default __exports__